var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"title":"Reviews","headers":_vm.headers,"allow-add":false,"loader":_vm.loadReviews},scopedSlots:_vm._u([{key:"type",fn:function(ref){
var item = ref.item;
return [_c('v-chip',[_vm._v(_vm._s(item.type))])]}},{key:"createdAt",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.formatDate(item.createdAt)))])]}},{key:"stepsToReproduce",fn:function(ref){
var item = ref.item;
return [(!item.stepsToReproduce)?_c('span',{staticStyle:{"color":"grey","font-style":"italic","font-size":"10px"}},[_vm._v(" None ")]):_c('span',[_vm._v(_vm._s(item.stepsToReproduce))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }